export const TITULO_PRINCIPAL = 'Plataforma Eletrônica para Bovinos';
